import { LoaderIcon } from "lucide-react";
import { HTMLAttributes } from "react";
import { UseSpinnerProps, useSpinner } from "./use-spinner";

export type SpinnerProps = UseSpinnerProps &
  Omit<HTMLAttributes<HTMLDivElement>, "color"> & {
    ref?: React.Ref<HTMLDivElement>;
  };

export function Spinner({ ref, ...props }: SpinnerProps) {
  const { classNames, getSpinnerProps, label, slots } = useSpinner({
    ...props,
  });

  return (
    <div ref={ref} {...getSpinnerProps()}>
      <div className={slots.wrapper({ class: classNames?.wrapper })}>
        <LoaderIcon className={slots.loader({ class: classNames?.loader })} />
      </div>
      {label && (
        <span className={slots.label({ class: classNames?.label })}>
          {label}
        </span>
      )}
    </div>
  );
}

Spinner.displayName = "RecareUI.Spinner";
